/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent, memo } from "react";

type Props = {
  className?: string;
};

const Logo: FunctionComponent<Props> = ({ className }) => (
  <svg
    className={clsx("block", className)}
    fill="none"
    viewBox="0 0 45 45"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 42.312c-10.86 0-19.807-9.017-19.807-19.855 0-2.255.434-4.422 1.13-6.503L15.375 38.41c.174.347.348.52.695.52.435 0 .522-.26.695-.52l5.387-11.965c.086-.173.173-.26.26-.26.174 0 .174.173.26.26l5.474 11.965c.174.347.347.52.695.52.434 0 .52-.26.695-.52L41.09 15.954c.695 1.994 1.13 4.162 1.13 6.503.086 10.838-8.862 19.855-19.721 19.855Zm0-24.971c-.174 0-.174-.173-.26-.26L16.07 3.728a19.244 19.244 0 0 1 12.858 0L22.76 17.081c-.087.087-.087.26-.261.26Zm-6.515 14.48c-.174 0-.174-.174-.261-.26L5.647 12.139c1.737-2.862 4.343-5.29 7.297-7.023l7.124 15.433c.173.347.347.434.52.434h3.736c.26 0 .435-.087.522-.434l7.123-15.433c2.954 1.647 5.56 4.075 7.297 7.023l-9.99 19.422c-.087.173-.174.26-.26.26-.174 0-.174-.174-.261-.26l-3.823-8.497c-.173-.347-.347-.434-.52-.434h-3.736c-.26 0-.435.087-.522.434l-3.909 8.497c-.087.086-.087.26-.26.26ZM22.5 45C35.01 45 45 34.942 45 22.543 45 10.145 35.01 0 22.5 0S0 10.058 0 22.457C0 34.855 10.077 45 22.5 45Z"
      fill="#000"
    />
  </svg>
);

export const VolkswagenLogo = memo(Logo);
